import { useSpecificPopup } from '@/composables/useSpecificPopup.ts'
import { useNotificationsStore } from '@/stores/useNotificationsStore'

let specificPopup: ReturnType<typeof useSpecificPopup> | null = null

export function useNotifications() {
  const notificationsStore = useNotificationsStore()

  if (!specificPopup) {
    specificPopup = useSpecificPopup('notificationsRequest')
  }

  const enableNotifications = async() => {
    localStorage.setItem('notificationsChoice', 'accepted')
    notificationsStore.requestNotificationsPermission()

    try {
      await notificationsStore.subscribeToPushApi()
    } catch (error) {
      console.error("subscribeToPushApi failed", error);
    }

    specificPopup?.hide()
  }

  const disableNotifications = () => {
    localStorage.setItem('notificationsChoice', 'declined')
    notificationsStore.disableNotifications()
    notificationsStore.unsubscribeFromPushApi()
    specificPopup?.hide()
  }

  const setNotificationsEnabled = (value) => {
    if (value) {
      enableNotifications()
    } else {
      disableNotifications()
    }
  }

  const enableEmailNotifications = () => {
    notificationsStore.subscribeToEmailNotifications()
  }

  const disableEmailNotifications = () => {
    notificationsStore.unsubscribeFromEmailNotifications()
  }

  const setEmailNotificationsEnabled = (value) => {
    if (value) {
      enableEmailNotifications()
    } else {
      disableEmailNotifications()
    }
  }

  return {
    enableNotifications,
    disableNotifications,
    setNotificationsEnabled,
    setEmailNotificationsEnabled,
    enableEmailNotifications,
    disableEmailNotifications,
  }
}
